import { useEffect } from 'react';
import { postMessageToRN } from '../../../utils/RNCommunicator/postMessageToRN.util';
import { useGetUserProfile } from '../../user/useGetUserProfile';

export const useRNSetUserId = () => {
  const { userProfile } = useGetUserProfile();

  useEffect(() => {
    if (!window.ReactNativeWebView) {
      return;
    }

    if (userProfile?.id) {
      postMessageToRN({ messageKey: 'setUserId', messageParam: userProfile.id });
    } else {
      postMessageToRN({ messageKey: 'setUserId', messageParam: 'anonymous_id' });
    }
  }, [userProfile]);
};
